//import settings from '../settings.json'

import { createSelector } from 'reselect'

import { number_format } from './number_format'

import pathIntranet from '../ruta'

//Actions
export const SET_SIZE_IMAGE_CONTAINER_HEIGHT = 'SET_SIZE_IMAGE_CONTAINER_HEIGHT'
export const SET_SIZE_IMAGE_CONTAINER_WIDTH = 'SET_SIZE_IMAGE_CONTAINER_WIDTH'
export const SET_HEIGHT_MENU = 'SET_HEIGHT_MENU'
export const SET_HEIGHT_VIEWPORT = 'SET_HEIGHT_VIEWPORT'
export const SET_VISIBLE = 'SET_VISIBLE'
export const SET_WIDTH_SLIDER_BUTTONS = 'SET_WIDTH_SLIDER_BUTTONS'
export const SET_WIDTH_BUTTON_ESTANCIA = 'SET_WIDTH_BUTTON_ESTANCIA'
export const SET_POSITION_X = 'SET_POSITION_X'
export const TOGGLE_OPEN_MENU = 'TOGGLE_OPEN_MENU'
export const CLOSE_MENU = 'CLOSE_MENU'
export const TOGGLE_OPEN_PROYECTO = 'TOGGLE_OPEN_PROYECTO'
export const CLOSE_PROYECTO = 'CLOSE_PROYECTO'
export const TOGGLE_RESUMEN = 'TOGGLE_RESUMEN'
export const TOGGLE_USUARIO = 'TOGGLE_USUARIO'
export const TOGGLE_OPCIONES_GUARDADAS = 'TOGGLE_OPCIONES_GUARDADAS'
export const TOGGLE_GENERATE_PDF = 'TOGGLE_GENERATE_PDF'
export const TOGGLE_PDF_LOADING = 'TOGGLE_PDF_LOADING'
export const SET_VISIBLE_DEFAULT = 'SET_VISIBLE_DEFAULT'
export const SET_DEFAULTS = 'SET_DEFAULTS'
export const SET_ID_ESTANCIA_ACTUAL = 'SET_ID_ESTANCIA_ACTUAL'
export const SET_IDIOMA = 'SET_IDIOMA'
export const SET_TOKEN = 'SET_TOKEN'
export const RESET_TOKEN = 'RESET_TOKEN'
export const RECUPERAR_CONFIGURACION = 'RECUPERAR_CONFIGURACION'
export const SET_CONFIGURACIONES = 'SET_CONFIGURACIONES'
export const SET_HEIGHT_HEADER = 'SET_HEIGHT_HEADER'
export const SET_IMAGE_LOADED = 'SET_IMAGE_LOADED'
export const SET_IMAGES_LOADING = 'SET_IMAGES_LOADING'
export const SET_URL = 'SET_URL'

export const SET_ID_PROYECTO = 'SET_ID_PROYECTO'
export const SET_LOADER = 'SET_LOADER'
export const SET_PRECIO_BASE = 'SET_PRECIO_BASE'
export const SET_LOGO_RESUMEN = 'SET_LOGO_RESUMEN'
export const SET_LOGO_PDF = 'SET_LOGO_PDF'
export const SET_LOGO_CONFIGURACIONES = 'SET_LOGO_CONFIGURACIONES'
export const SET_NOMBRE_PDF = 'SET_NOMBRE_PDF'
export const SET_GA_ID = 'SET_GA_ID'
export const SET_GRUPO_PROYECTO = 'SET_GRUPO_PROYECTO'

const initialState = {
  loaded: false,
  idioma: 'es',

  url: {
    pathname: '',
    href: '',
    search: ''
  },

  sizeImageContainer: {
    width: 0,
    height: 0
  },
  heightMenu: 0,
  heightViewport: 0,
  widthSliderButtons: 0,
  positionX: 0,
  openMenu: false,
  openProyecto: false,
  openResumen: false,
  openUsuario: false,
  usuarioWithOpciones: false,
  openOpcionesGuardadas: false,
  generatePdf: false,
  pdfLoading: false,
  imagesLoading: [],

  loadedEstancias: false,
  loadedAcabados: false,
  loadedOpciones: false,

  textos: {
    informacion:
      'La información, infografías y documentación gráfica que aparecen es este folleto son orientativas, pueden incluir acabados extras no incluidos y están sujetas a modificaciones derivadas del proyecto definitivo y de su construcción. Todo el mobiliario es meramente decorativo. La restante información contemplada en el R.D. 218/2005 de la Junta de Andalucía se encuentra en nuestras oficinas para su consulta.',
    cerrar: 'Cerrar',
    iva: '(IVA no incluido)',
    botonResumen: 'Ver resumen',
    botonReset: '¿Borrar selección?',
    generarPDF: 'Generar PDF',
    guardarConfiguraciones: 'Guardar configuraciones',
    miPerfil: 'Mi perfil',
    configuraciones: 'Configuraciones',
    cerrarSesion: 'Cerrar sesión',
    guardar: 'Guardar',
    configuracion: 'Configuración',
    maximoConfiguraciones: 'Máximo configuraciones alcanzado',
    recuperar: 'Recuperar',
    eliminar: 'Eliminar',
    perfilUsuario: 'Perfil de usuario',
    cookies:
      'Utilizamos cookies propias y de terceros para elaborar información estadística a través del análisis de tu navegación.',
    aceptar: 'Aceptar',
    rechazar: 'Rechazar',
    enviarCorreo: 'Enviar por correo electrónico',
    legal:
      'Como Responsable del Tratamiento, Lar Inmobiliaria, le informa de que los datos contenidos en este formulario serán utilizados con la finalidad de gestionar el envío de información y prospección comercial en base al consentimiento expresamente otorgado. Sus datos serán cedidos a compañías del grupo, proveedores con las garantías necesarias y organismos públicos por obligación legal. Podrá revocar este consentimiento y ejercer el resto de los derechos relativos a sus datos de acuerdo con nuestra política de privacidad.',
    errorEmail: 'Introduzca un email valido.',
    noUser:
      'No existe ningun usuario con el email proporcionado. Por favor registre un nuevo usuario.',
    avisoCorreo:
      'Se le ha enviado un correo con un enlace para acceder a las configuraciones guardadas.',
    identificarse: 'Identificarse',
    registrarUsuario: 'Registrar nuevo usuario',
    email: 'Email',
    nombre: 'Nombre',
    movil: 'Móvil (opcional)',
    codigoPostal: 'Código postal (opcional)',
    acepto: 'Acepto los ',
    terminos: 'terminos y condiciones',
    errorConfiguraciones: 'No ha sido posible guardar las configuraciones.',
    errorCondiciones: 'Debe aceptar las condiciones de uso.',
    errorNombre: 'Debe introducir un nombre.',
    crearUsuario: 'Crear usuario',
    headerPdf: 'TU VIVIENDA PERSONALIZADA'
  },

  textosIngles: {
    informacion:
      'Information, computer graphics and graphic documentation that appear in this brochure are indicative, finishes may include extras not included and are subject to changes arising from final project and its construction. All the furniture is merely decorative. The other information referred to in R.D.218/2005 of the Government of Andalusia, is available in our offices for consultation.',
    cerrar: 'Close',
    iva: '(VAT not included)',
    botonResumen: 'View summary',
    botonReset: 'Reset selection?',
    generarPDF: 'Generate PDF',
    guardarConfiguraciones: 'Save configurations',
    miPerfil: 'My profile',
    configuraciones: 'Configurations',
    cerrarSesion: 'Close session',
    guardar: 'Save',
    configuracion: 'Configuration',
    maximoConfiguraciones: 'Maximum settings reached',
    recuperar: 'Load',
    eliminar: 'Remove',
    perfilUsuario: 'User profile',
    cookies:
      'We use our own and third-party cookies to prepare statistical information through the analysis of your browsing.',
    aceptar: 'Agree',
    rechazar: 'Decline',
    enviarCorreo: 'Send by e-mail',
    legal:
      'As a Processing Manager, Lar Inmobiliaria informs you that the data contained in this form will be used for the purpose of managing the sending of information and commercial research, based on the expressly granted consent. Your data will be transferred to companies in the group, providers with the necessary guarantees and public bodies due to legal obligation. You may revoke this consent and exercise the other rights relating to your data in accordance with our privacy policy.',
    errorEmail: 'Enter a valid email.',
    noUser:
      'There is no user with the email provided. Please register a new user.',
    avisoCorreo:
      'You have been sent an email with a link to access the saved settings.',
    identificarse: 'Identify',
    registrarUsuario: 'Register new user',
    email: 'E-mail',
    nombre: 'Name',
    movil: 'Mobile (optional)',
    codigoPostal: 'Zip code (optional)',
    acepto: 'I accept the ',
    terminos: 'terms and conditions',
    errorConfiguraciones:
      'It has not been possible to save the configurations.',
    errorCondiciones: 'You must accept the conditions of use.',
    errorNombre: 'You must enter a name.',
    crearUsuario: 'Create user',
    headerPdf: 'YOUR CUSTOMIZED HOUSING'
  }
}

export const setSizeImageContainerHeight = height => ({
  type: SET_SIZE_IMAGE_CONTAINER_HEIGHT,
  height
})

export const setSizeImageContainerWidth = width => ({
  type: SET_SIZE_IMAGE_CONTAINER_WIDTH,
  width
})

export const setHeightMenu = height => ({
  type: SET_HEIGHT_MENU,
  height
})

export const setHeightViewport = height => ({
  type: SET_HEIGHT_VIEWPORT,
  height
})

export const setVisible = (acabado, opcion) => ({
  type: SET_VISIBLE,
  acabado,
  opcion
})

export const setWidthSliderButtons = width => ({
  type: SET_WIDTH_SLIDER_BUTTONS,
  width
})

export const setWidthButtonEstancia = (index, width) => ({
  type: SET_WIDTH_BUTTON_ESTANCIA,
  index,
  width
})

export const setPositionX = positionX => ({
  type: SET_POSITION_X,
  positionX
})

export const toggleOpenMenu = () => ({
  type: TOGGLE_OPEN_MENU
})

export const closeMenu = () => ({
  type: CLOSE_MENU
})

export const toggleOpenProyecto = () => ({
  type: TOGGLE_OPEN_PROYECTO
})

export const closeProyecto = () => ({
  type: CLOSE_PROYECTO
})

export const toggleResumen = () => ({
  type: TOGGLE_RESUMEN
})

export const toggleUsuario = withOpciones => ({
  type: TOGGLE_USUARIO,
  withOpciones
})

export const toggleOpcionesGuardadas = () => ({
  type: TOGGLE_OPCIONES_GUARDADAS
})

export const toggleGeneratePdf = () => ({
  type: TOGGLE_GENERATE_PDF
})

export const togglePdfLoading = () => ({
  type: TOGGLE_PDF_LOADING
})

export const setVisibleDefault = (idAcabado, idOpcion) => ({
  type: SET_VISIBLE_DEFAULT,
  idAcabado,
  idOpcion
})

export const setDefaults = () => ({
  type: SET_DEFAULTS
})

export const setIdEstanciaActual = path => ({
  type: SET_ID_ESTANCIA_ACTUAL,
  path
})

export const setIdioma = idioma => ({
  type: SET_IDIOMA,
  idioma
})

export const setToken = ({ token, idUsuario, configuraciones, idioma }) => ({
  type: SET_TOKEN,
  token,
  idUsuario,
  configuraciones,
  idioma
})

export const resetToken = () => ({
  type: RESET_TOKEN
})

export const recuperarConfiguracion = nid => ({
  type: RECUPERAR_CONFIGURACION,
  nid
})

export const setConfiguraciones = configuraciones => ({
  type: SET_CONFIGURACIONES,
  configuraciones
})

export const setIdProyecto = idProyecto => ({
  type: SET_ID_PROYECTO,
  idProyecto
})

export const setLoader = (
  estancias,
  ordenEstancias,
  acabados,
  opciones,
  subopciones
) => ({
  type: SET_LOADER,
  estancias,
  ordenEstancias,
  acabados,
  opciones,
  subopciones
})

export const setGrupoProyecto = grupos => ({
  type: SET_GRUPO_PROYECTO,
  grupos
})

export const setPrecioBase = precio => ({
  type: SET_PRECIO_BASE,
  precio
})

export const setLogoResumen = src => ({
  type: SET_LOGO_RESUMEN,
  src
})

export const setLogoPdf = src => ({
  type: SET_LOGO_PDF,
  src
})

export const setLogoConfiguraciones = src => ({
  type: SET_LOGO_CONFIGURACIONES,
  src
})

export const setNombrePdf = nombre => ({
  type: SET_NOMBRE_PDF,
  nombre
})

export const setHeightHeader = height => ({
  type: SET_HEIGHT_HEADER,
  height
})

export const setUrl = url => ({
  type: SET_URL,
  url
})

export const setGAId = id => ({
  type: SET_GA_ID,
  id
})

export const setImageLoaded = image => ({
  type: SET_IMAGE_LOADED,
  image
})

export const setImagesLoading = images => ({
  type: SET_IMAGES_LOADING,
  images
})

const searchId = (items, id) => {
  for (let i = 0, iLen = items.length; i < iLen; i++) {
    if (items[i].id === id) {
      return items[i]
    }
  }

  return null
}

const searchPath = (estancias, path) => {
  for (let i = 0, iLen = estancias.length; i < iLen; i++) {
    if (estancias[i].path === path) {
      return estancias[i].id
    }
  }

  return null
}

const updateId = (origItems, id, field, value) => {
  const items = [...origItems]

  for (let i = 0, iLen = items.length; i < iLen; i++) {
    if (items[i].id === id) {
      if (value instanceof Function) {
        items[i][field] = value(items[i])
      } else {
        items[i][field] = value
      }

      return items
    }
  }

  return items
}

const setEstanciasState = (state, action) => {
  const widthButtonEstancia = action.ordenEstancias.map(estancia => 0)

  const estancias = action.ordenEstancias.map(idEstancia => {
    const estancia = searchId(action.estancias, idEstancia)

    const size = estancia.size.split('_')
    const path = estancia.path === '' ? estancia.id : estancia.path
    const acabados = estancia.acabados.split(',')
    const nameButton =
      estancia.nameButton === '' ? estancia.title : estancia.nameButton
    const nameButtonIngles =
      estancia.nameButtonIngles === ''
        ? estancia.titleIngles
        : estancia.nameButtonIngles

    return {
      id: estancia.id,
      nameButton,
      nameButtonIngles,
      title: estancia.title,
      titleIngles: estancia.titleIngles,
      src: `${pathIntranet}${estancia.src}`,
      width: size[0],
      height: size[1],
      acabados,
      path,
      pdfIconosLinea: estancia.pdficonoslinea * 1
    }
  })

  const srcEstanciasLoaded = estancias.map(estancia => ({
    id: estancia.id,
    loaded: false
  }))

  return {
    estancias,
    widthButtonEstancia,
    idEstanciaActual: estancias[0].id,
    srcEstanciasLoaded
  }
}

const setAcabadosState = (state, action) => {
  const acabados = action.acabados.map(acabado => {
    const opciones = acabado.opciones.split(',')

    return {
      id: acabado.id,
      title: acabado.title,
      titleIngles: acabado.titleIngles,
      multiple: acabado.multiple === '1',
      opciones,
      parentAcabado: ''
    }
  })

  return {
    acabados
  }
}

const setOpcionesState = (state, action) => {
  const opciones = action.opciones.map(opcion => {
    const size = opcion.size.split('_')
    const srcIconoPdf =
      opcion.srcIconoPdf === ''
        ? []
        : opcion.srcIconoPdf.split(',').map(src => `${pathIntranet}${src}`)

    return {
      id: opcion.id,
      title: opcion.title,
      titleIngles: opcion.titleIngles,
      subtitle: opcion.subtitle,
      subtitleIngles: opcion.subtitleIngles,
      srcIcono: `${pathIntranet}${opcion.srcIcono}`,
      precio: opcion.precio * 1,
      src: `${pathIntranet}${opcion.src}`,
      width: size[0],
      height: size[1],
      srcIconoPdf,
      subOpciones: []
    }
  })

  return {
    opciones
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SIZE_IMAGE_CONTAINER_HEIGHT:
      const size0 = { ...state.sizeImageContainer }
      size0.height = action.height

      return {
        ...state,
        sizeImageContainer: size0
      }
    case SET_SIZE_IMAGE_CONTAINER_WIDTH:
      const size = { ...state.sizeImageContainer }
      size.width = action.width

      return {
        ...state,
        sizeImageContainer: size
      }
    case SET_HEIGHT_MENU:
      return {
        ...state,
        heightMenu: action.height
      }
    case SET_HEIGHT_VIEWPORT:
      return {
        ...state,
        heightViewport: action.height
      }
    case SET_VISIBLE:
      const { multiple } = searchId(state.acabados, action.acabado)

      let opcionesAcabado = []

      if (multiple) {
        opcionesAcabado = [
          ...searchId(state.opcionesSeleccionadas, action.acabado).opciones
        ]

        const index = opcionesAcabado.indexOf(action.opcion)

        if (index === -1) {
          opcionesAcabado.push(action.opcion)
        } else {
          opcionesAcabado.splice(index, 1)
        }
      } else {
        opcionesAcabado = [action.opcion]
      }

      const opcionesSeleccionadas6 = updateId(
        state.opcionesSeleccionadas,
        action.acabado,
        'opciones',
        opcionesAcabado
      )

      return {
        ...state,
        opcionesSeleccionadas: opcionesSeleccionadas6
      }
    case SET_WIDTH_SLIDER_BUTTONS:
      return {
        ...state,
        widthSliderButtons: action.width
      }
    case SET_WIDTH_BUTTON_ESTANCIA:
      const widths = [...state.widthButtonEstancia]
      widths[action.index] = action.width

      return {
        ...state,
        widthButtonEstancia: widths
      }
    case SET_POSITION_X:
      return {
        ...state,
        positionX: action.positionX
      }
    case TOGGLE_OPEN_MENU:
      return {
        ...state,
        openMenu: !state.openMenu
      }
    case CLOSE_MENU:
      return {
        ...state,
        openMenu: false
      }
    case TOGGLE_OPEN_PROYECTO:
      return {
        ...state,
        openProyecto: !state.openProyecto
      }
    case CLOSE_PROYECTO:
      return {
        ...state,
        openProyecto: false
      }
    case TOGGLE_RESUMEN:
      return {
        ...state,
        openResumen: !state.openResumen
      }
    case TOGGLE_USUARIO:
      return {
        ...state,
        openUsuario: !state.openUsuario,
        usuarioWithOpciones: state.openUsuario ? false : action.withOpciones
      }
    case TOGGLE_OPCIONES_GUARDADAS:
      return {
        ...state,
        openOpcionesGuardadas: !state.openOpcionesGuardadas
      }
    case TOGGLE_GENERATE_PDF:
      return {
        ...state,
        generatePdf: !state.generatePdf
      }
    case TOGGLE_PDF_LOADING:
      return {
        ...state,
        pdfLoading: !state.pdfLoading
      }
    case SET_VISIBLE_DEFAULT:
      const acabado = searchId(state.acabados, action.idAcabado)

      let opcionesSeleccionadas1 = []

      if (acabado.multiple) {
        let { opciones: opS } = searchId(
          state.opcionesSeleccionadas,
          action.idAcabado
        )

        const opS1 = []

        for (let i = 0, iLen = opS.length; i < iLen; i++) {
          if (opS[i] !== action.idOpcion) {
            opS1.push(opS[i])
          }
        }

        opcionesSeleccionadas1 = updateId(
          state.opcionesSeleccionadas,
          action.idAcabado,
          'opciones',
          opS1
        )
      } else {
        opcionesSeleccionadas1 = updateId(
          state.opcionesSeleccionadas,
          action.idAcabado,
          'opciones',
          acabado.opciones.length > 0 ? [acabado.opciones[0]] : []
        )
      }

      return {
        ...state,
        opcionesSeleccionadas: opcionesSeleccionadas1
      }
    case SET_DEFAULTS:
      const opcionesSeleccionadas2 = state.acabados.map(acabado => {
        return {
          id: acabado.id,
          opciones: acabado.multiple ? [] : [acabado.opciones[0]]
        }
      })

      return {
        ...state,
        opcionesSeleccionadas: opcionesSeleccionadas2
      }
    case SET_ID_ESTANCIA_ACTUAL:
      let idEstanciaActual1 = state.estancias[0].id
      if (typeof action.path !== 'undefined') {
        idEstanciaActual1 = searchPath(state.estancias, action.path)
        if (idEstanciaActual1 === null) {
          idEstanciaActual1 = state.estancias[0].id
        }
      }

      return {
        ...state,
        idEstanciaActual: idEstanciaActual1
      }
    case SET_IDIOMA:
      return {
        ...state,
        idioma: action.idioma
      }
    case SET_TOKEN:
      const configuraciones = action.configuraciones.map(configuracion => {
        const estancias = state.estancias.map(estancia => {
          const confEstancia = searchId(configuracion.estancias, estancia.id)

          if (confEstancia === null) {
            const acabados2 = estancia.acabados.map(idAcabado => {
              const acabado = searchId(state.acabados, idAcabado)

              const opciones = acabado.multiple ? [] : [acabado.opciones[0]]

              return {
                id: acabado.id,
                opciones
              }
            })

            return {
              id: estancia.id,
              acabados: acabados2
            }
          } else {
            const acabados1 = estancia.acabados.map(idAcabado => {
              const acabado = searchId(state.acabados, idAcabado)

              const confAcabado = searchId(confEstancia.acabados, acabado.id)

              if (confAcabado === null) {
                return acabado.multiple
                  ? { id: acabado.id, opciones: [] }
                  : { id: acabado.id, opciones: [acabado.opciones[0]] }
              } else {
                const confOpciones = confAcabado.opciones.reduce(
                  (resultOpciones, idOpcion) => {
                    if (acabado.opciones.indexOf(idOpcion) !== -1) {
                      resultOpciones.push(idOpcion)
                    }
                    return resultOpciones
                  },
                  []
                )

                return confOpciones.length === 0
                  ? acabado.multiple
                    ? { id: acabado.id, opciones: [] }
                    : { id: acabado.id, opciones: [acabado.opciones[0]] }
                  : {
                      id: acabado.id,
                      opciones: confOpciones
                    }
              }
            })

            return {
              id: estancia.id,
              acabados: acabados1
            }
          }
        })

        return {
          id: configuracion.id,
          estancias
        }
      })

      return {
        ...state,
        token: action.token,
        idUsuario: action.idUsuario,
        configuracionesGuardadas: configuraciones, //action.configuraciones,
        openMenu: false,
        openProyecto: false,
        openResumen: false,
        openUsuario: false,
        openOpcionesGuardadas: false,
        idioma:
          action.idioma !== 'es' && action.idioma !== 'en'
            ? 'es'
            : action.idioma
      }
    case RESET_TOKEN:
      return {
        ...state,
        token: undefined,
        idUsuario: undefined,
        configuracionesGuardadas: undefined,
        openMenu: false,
        openProyecto: false,
        openResumen: false,
        openUsuario: false,
        openOpcionesGuardadas: false
      }
    case SET_URL:
      return {
        ...state,
        url: action.url
      }
    case SET_CONFIGURACIONES:
      return {
        ...state,
        configuracionesGuardadas: action.configuraciones
      }
    case RECUPERAR_CONFIGURACION:
      let opcionesSeleccionadas4 = [...state.opcionesSeleccionadas]
      const configuracion = searchId(state.configuracionesGuardadas, action.nid)

      configuracion.estancias.forEach(estancia => {
        estancia.acabados.forEach(acabado => {
          opcionesSeleccionadas4 = updateId(
            opcionesSeleccionadas4,
            acabado.id,
            'opciones',
            acabado.opciones
          )
        })
      })

      return {
        ...state,
        opcionesSeleccionadas: opcionesSeleccionadas4,
        openOpcionesGuardadas: false
      }
    case SET_ID_PROYECTO:
      return {
        ...state,
        idProyecto: action.idProyecto
      }
    case SET_GA_ID:
      return {
        ...state,
        gaId: action.id
      }
    case SET_HEIGHT_HEADER:
      return {
        ...state,
        heightHeader: action.height
      }
    case SET_IMAGE_LOADED:
      let srcEstanciasLoaded1 = [...state.srcEstanciasLoaded]
      let srcOpcionesLoaded1 = [...state.srcOpcionesLoaded]

      if (action.image.tipo === 'estancia') {
        srcEstanciasLoaded1 = updateId(
          srcEstanciasLoaded1,
          action.image.id,
          'loaded',
          true
        )
      } else if (action.image.tipo === 'opcion') {
        srcOpcionesLoaded1 = updateId(
          srcOpcionesLoaded1,
          action.image.id,
          'loaded',
          true
        )
      }

      const loaded3 = state.imagesLoading.reduce((result, image) => {
        if (image.tipo === 'estancia') {
          return result && searchId(srcEstanciasLoaded1, image.id).loaded
        } else if (image.tipo === 'opcion') {
          return result && searchId(srcOpcionesLoaded1, image.id).loaded
        } else {
          return false
        }
      }, true)

      if (loaded3) {
        return {
          ...state,
          srcEstanciasLoaded: srcEstanciasLoaded1,
          srcOpcionesLoaded: srcOpcionesLoaded1,
          imagesLoading: []
        }
      } else {
        return {
          ...state,
          srcEstanciasLoaded: srcEstanciasLoaded1,
          srcOpcionesLoaded: srcOpcionesLoaded1
        }
      }
    case SET_IMAGES_LOADING:
      const imagesLoading = [...state.imagesLoading]
      const numI = imagesLoading.length

      action.images.forEach(image => {
        if (
          !imagesLoading.some(
            im => im.tipo === image.tipo && im.id === image.id
          )
        ) {
          imagesLoading.push(image)
        }
      })

      if (numI !== imagesLoading.length) {
        return {
          ...state,
          imagesLoading
        }
      } else {
        return state
      }
    case SET_LOADER:
      const {
        estancias,
        widthButtonEstancia,
        idEstanciaActual,
        srcEstanciasLoaded
      } = setEstanciasState(state, action)
      const { acabados } = setAcabadosState(state, action)
      const { opciones } = setOpcionesState(state, action)

      action.subopciones.forEach(subopcion => {
        const size = subopcion.size.split('_')
        const srcIconoPdf =
          subopcion.srcIconoPdf === ''
            ? []
            : subopcion.srcIconoPdf
                .split(',')
                .map(src => `${pathIntranet}${src}`)

        const subopcion1 = {
          id: subopcion.id,
          title: subopcion.title,
          titleIngles: subopcion.titleIngles,
          subtitle: subopcion.subtitle,
          subtitleIngles: subopcion.subtitleIngles,
          srcIcono: `${pathIntranet}${subopcion.srcIcono}`,
          precio: subopcion.precio * 1,
          src: `${pathIntranet}${subopcion.src}`,
          width: size[0],
          height: size[1],
          srcIconoPdf
        }

        const newIdAcabado = `${subopcion.titleAcabado}${subopcion.idEstancia}`

        let indexAcabado = -1
        for (let j = 0, jLen = acabados.length; j < jLen; j++) {
          if (acabados[j].id === newIdAcabado) {
            indexAcabado = j
          }
        }

        if (indexAcabado === -1) {
          acabados.push({
            id: newIdAcabado,
            title: subopcion.titleAcabado,
            titleIngles: subopcion.titleAcabadoIngles,
            multiple: true,
            opciones: [],
            parentAcabado: subopcion.idAcabado
          })
          indexAcabado = acabados.length - 1

          for (let i = 0, iLen = estancias.length; i < iLen; i++) {
            if (estancias[i].id === subopcion.idEstancia) {
              let indexAcabado1 = -1
              for (
                let j = 0, jLen = estancias[i].acabados.length;
                j < jLen;
                j++
              ) {
                if (estancias[i].acabados[j] === subopcion.idAcabado) {
                  indexAcabado1 = j
                }
              }

              if (indexAcabado1 === -1) {
                console.log('No encuentra acabado')
              } else if (indexAcabado1 === estancias[i].acabados.length - 1) {
                estancias[i].acabados.push(newIdAcabado)
              } else if (
                estancias[i].acabados[indexAcabado1].id !== newIdAcabado
              ) {
                estancias[i].acabados.splice(indexAcabado1 + 1, 0, newIdAcabado)
              }
            }
          }
        }

        if (indexAcabado !== -1) {
          acabados[indexAcabado].opciones.push(subopcion.id)
        }

        for (let j = 0, jLen = opciones.length; j < jLen; j++) {
          if (opciones[j].id === subopcion.idOpcion) {
            opciones[j].subOpciones.push(subopcion.id)
          }
        }

        opciones.push(subopcion1)
      })

      const opcionesSeleccionadas = acabados.map(acabado => {
        return {
          id: acabado.id,
          opciones: acabado.multiple ? [] : [acabado.opciones[0]]
        }
      })

      const srcOpcionesLoaded = opciones.map(opcion => ({
        id: opcion.id,
        loaded: false
      }))

      return {
        ...state,
        estancias,
        widthButtonEstancia,
        idEstanciaActual,
        srcEstanciasLoaded,
        acabados,
        opciones,
        opcionesSeleccionadas,
        srcOpcionesLoaded,
        loaded: true
      }

    case SET_GRUPO_PROYECTO:
      const grupoProyecto = action.grupos.map(grupo => ({
        id: grupo.nid,
        title: grupo.title,
        titleIngles: grupo.titleIngles,
        url: grupo.url
      }))

      return {
        ...state,
        grupoProyecto
      }
    case SET_PRECIO_BASE:
      return {
        ...state,
        precioBase: action.precio
      }
    case SET_LOGO_RESUMEN:
      return {
        ...state,
        srcLogoResumen: action.src
      }
    case SET_LOGO_PDF:
      return {
        ...state,
        srcLogoPdf: action.src
      }
    case SET_LOGO_CONFIGURACIONES:
      return {
        ...state,
        srcLogoConfiguraciones: action.src
      }
    case SET_NOMBRE_PDF:
      return {
        ...state,
        nombrePdf: action.nombre
      }
    default:
      return state
  }
}

const estanciasSelector = state => state.estancias
const acabadosSelector = state => state.acabados
const opcionesSelector = state => state.opciones
const idEstanciaActualSelector = state => state.idEstanciaActual
const opcionesSeleccionadasSelector = state => state.opcionesSeleccionadas
//const opcionesGuardadasSelector = state => state.opcionesGuardadas
const idiomaSelector = state => state.idioma
const precioBaseSelector = state => state.precioBase
const srcEstanciasLoadedSelector = state => state.srcEstanciasLoaded
const srcOpcionesLoadedSelector = state => state.srcOpcionesLoaded
const imagesLoadingSelector = state => state.imagesLoading
const grupoProyectoSelector = state => state.grupoProyecto
const idProyectoSelector = state => state.idProyecto
const configuracionesGuardadasSelector = state => state.configuracionesGuardadas

export const getPorcentajeLoaded = createSelector(
  [
    srcEstanciasLoadedSelector,
    srcOpcionesLoadedSelector,
    imagesLoadingSelector
  ],
  (srcEstanciasLoaded, srcOpcionesLoaded, imagesLoading) => {
    const num = imagesLoading.length

    if (num === 0) return 100

    const numLoaded = imagesLoading.reduce((result, image) => {
      if (image.tipo === 'estancia') {
        return searchId(srcEstanciasLoaded, image.id).loaded
          ? result + 1
          : result
      } else if (image.tipo === 'opcion') {
        return searchId(srcOpcionesLoaded, image.id).loaded
          ? result + 1
          : result
      } else {
        return result
      }
    }, 0)

    return Math.round((numLoaded * 100) / num)
  }
)

export const getGrupoProyectoActual = createSelector(
  [grupoProyectoSelector, idProyectoSelector,idiomaSelector],
  (grupoProyecto, idProyecto,idioma) => {
    if (typeof grupoProyecto !== 'undefined') {
      const proyecto = searchId(grupoProyecto, idProyecto)

      return {
        id: proyecto.id,
        title: idioma === 'es' ? proyecto.title : proyecto.titleIngles,
        url: proyecto.url
      }
    }
    return undefined
  }
)

export const getEstancias = createSelector(
  [estanciasSelector],
  estancias => estancias.map(estancia => estancia.id)
)

export const getEstanciaButton = idEstancia =>
  createSelector(
    [estanciasSelector, idiomaSelector, idEstanciaActualSelector],
    (estancias, idioma, idEstanciaActual) => {
      const estancia = searchId(estancias, idEstancia)

      return {
        path: `/${idioma}/${estancia.path}`,
        nameButton:
          idioma === 'es' ? estancia.nameButton : estancia.nameButtonIngles,
        active: idEstancia === idEstanciaActual
      }
    }
  )

export const getMenu = createSelector(
  [estanciasSelector, idiomaSelector, idEstanciaActualSelector],
  (estancias, idioma, idEstanciaActual) => {
    if (typeof estancias === 'undefined') return { idioma: '', path: '' }

    const { path } = searchId(estancias, idEstanciaActual)

    return { idioma, path }
  }
)

const getSubtotalAcabados = (
  idAcabados,
  acabados,
  opciones,
  opcionesSeleccionadas
) =>
  idAcabados.reduce((result, idAcabado) => {
    const acabado = searchId(acabados, idAcabado)

    const idOpciones =
      acabado.parentAcabado !== ''
        ? getSubopcionesValidas(
            idAcabado,
            acabado.parentAcabado,
            opciones,
            opcionesSeleccionadas
          ).subopcionesSeleccionadas
        : searchId(opcionesSeleccionadas, idAcabado).opciones

    return (
      result +
      idOpciones.reduce((result1, idOpcion) => {
        const { precio } = searchId(opciones, idOpcion)
        return result1 + precio
      }, 0)
    )
  }, 0)

export const getSubtotal = createSelector(
  [
    estanciasSelector,
    acabadosSelector,
    opcionesSelector,
    opcionesSeleccionadasSelector,
    idEstanciaActualSelector
  ],
  (estancias, acabados, opciones, opcionesSeleccionadas, idEstanciaActual) => {
    const { acabados: idAcabados } = searchId(estancias, idEstanciaActual)

    const precio = getSubtotalAcabados(
      idAcabados,
      acabados,
      opciones,
      opcionesSeleccionadas
    )

    return number_format(precio, 2, ',', '.')
  }
)

export const getTotal = createSelector(
  [
    estanciasSelector,
    acabadosSelector,
    opcionesSelector,
    opcionesSeleccionadasSelector,
    precioBaseSelector
  ],
  (estancias, acabados, opciones, opcionesSeleccionadas, precioBase) => {
    const precio = estancias.reduce(
      (result1, estancia) =>
        result1 +
        getSubtotalAcabados(
          estancia.acabados,
          acabados,
          opciones,
          opcionesSeleccionadas
        ),
      precioBase
    )

    return number_format(precio, 2, ',', '.')
  }
)

/*export const getTotal = createSelector(
  [
    estanciasSelector,
    opcionesSelector,
    opcionesSeleccionadasSelector,
    precioBaseSelector
  ],
  (estancias, opciones, opcionesSeleccionadas, precioBase) => {
    const precio = estancias.reduce((result1, estancia) => {
      const idAcabados = estancia.acabados

      return (
        result1 +
        idAcabados.reduce((result, idAcabado) => {
          const { opciones: idOpciones } = searchId(
            opcionesSeleccionadas,
            idAcabado
          )

          return (
            result +
            idOpciones.reduce((result2, idOpcion) => {
              const { precio } = searchId(opciones, idOpcion)

              return result2 + precio
            }, 0)
          )
        }, 0)
      )
    }, precioBase)

    return number_format(precio, 2, ',', '.')
  }
)*/

const getSubopcionesValidas = (
  idAcabado,
  idParentAcabado,
  opciones,
  opcionesSeleccionadas
) => {
  const { opciones: idOpcionesSeleccionadasParent } = searchId(
    opcionesSeleccionadas,
    idParentAcabado
  )

  const subopcionesValidas = idOpcionesSeleccionadasParent.reduce(
    (result, idOpcionParent) => {
      const { subOpciones } = searchId(opciones, idOpcionParent)

      return result.concat(subOpciones)
    },
    []
  )

  const subopcionesSeleccionadas = searchId(
    opcionesSeleccionadas,
    idAcabado
  ).opciones.reduce((result, op) => {
    if (subopcionesValidas.indexOf(op) !== -1) {
      result.push(op)
    }

    return result
  }, [])

  return {
    subopcionesValidas,
    subopcionesSeleccionadas
  }
}

export const getAcabado = idAcabado =>
  createSelector(
    [
      acabadosSelector,
      opcionesSeleccionadasSelector,
      idiomaSelector,
      opcionesSelector
    ],
    (acabados, opcionesSeleccionadas, idioma, opciones) => {
      const acabado = searchId(acabados, idAcabado)

      let opciones1 = []
      let opcionesSeleccionadas1 = []
      if (acabado.parentAcabado !== '') {
        const {
          subopcionesValidas,
          subopcionesSeleccionadas
        } = getSubopcionesValidas(
          acabado.id,
          acabado.parentAcabado,
          opciones,
          opcionesSeleccionadas
        )

        opciones1 = subopcionesValidas
        opcionesSeleccionadas1 = subopcionesSeleccionadas
      } else {
        opciones1 = acabado.opciones
        opcionesSeleccionadas1 = searchId(opcionesSeleccionadas, idAcabado)
          .opciones
      }

      return {
        ...acabado,
        id: acabado.id,
        title: idioma === 'es' ? acabado.title : acabado.titleIngles,
        gaTitle: acabado.title,
        opciones: opciones1,
        opcionesSeleccionadas: opcionesSeleccionadas1
      }
    }
  )

export const getOpcionMenu = idOpcion =>
  createSelector(
    [opcionesSelector, idiomaSelector],
    (opciones, idioma) => {
      const opcion = searchId(opciones, idOpcion)

      return {
        title: idioma === 'es' ? opcion.title : opcion.titleIngles,
        subtitle: idioma === 'es' ? opcion.subtitle : opcion.subtitleIngles,
        srcIcono: opcion.srcIcono,
        precio: number_format(opcion.precio, 2, ',', '.')
      }
    }
  )

export const getAcabados = createSelector(
  [estanciasSelector, idEstanciaActualSelector],
  (estancias, idEstanciaActual) => {
    const { acabados: idAcabados } = searchId(estancias, idEstanciaActual)

    return idAcabados
  }
)

export const getImagesVisible = createSelector(
  [
    estanciasSelector,
    acabadosSelector,
    opcionesSelector,
    opcionesSeleccionadasSelector,
    idEstanciaActualSelector,
    srcEstanciasLoadedSelector,
    srcOpcionesLoadedSelector
  ],
  (
    estancias,
    acabados,
    opciones,
    opcionesSeleccionadas,
    idEstanciaActual,
    srcEstanciasLoaded,
    srcOpcionesLoaded
  ) => {
    const result = []

    const estanciaActual = searchId(estancias, idEstanciaActual)
    const estanciaActualLoaded = searchId(srcEstanciasLoaded, idEstanciaActual)

    result.push({
      id: 'e' + estanciaActual.id,
      src: estanciaActual.src,
      width: estanciaActual.width,
      height: estanciaActual.height,
      visible: true,
      loaded: estanciaActualLoaded.loaded,
      tipo: 'estancia'
    })

    estanciaActual.acabados.forEach(idAcabado => {
      const { opciones: idOpciones, parentAcabado } = searchId(
        acabados,
        idAcabado
      )

      const opcionesSeleccionadas1 =
        parentAcabado !== ''
          ? getSubopcionesValidas(
              idAcabado,
              parentAcabado,
              opciones,
              opcionesSeleccionadas
            ).subopcionesSeleccionadas
          : searchId(opcionesSeleccionadas, idAcabado).opciones

      idOpciones.forEach(idOpcion => {
        const opcion = searchId(opciones, idOpcion)

        if (opcion.src !== pathIntranet) {
          const srcOpcionLoaded = searchId(srcOpcionesLoaded, opcion.id)

          result.push({
            id: opcion.id,
            src: opcion.src,
            width: opcion.width,
            height: opcion.height,
            visible: opcionesSeleccionadas1.indexOf(opcion.id) !== -1,
            loaded: srcOpcionLoaded.loaded,
            tipo: 'opcion'
          })
        }
      })
    })

    return result
  }
)

export const getOpcionesSeleccionadas = createSelector(
  [
    estanciasSelector,
    acabadosSelector,
    opcionesSelector,
    opcionesSeleccionadasSelector,
    idiomaSelector
  ],
  (estancias, acabados, opciones, opcionesSeleccionadas, idioma) => {
    const result = []

    estancias.forEach(estancia => {
      estancia.acabados.forEach(idAcabado => {
        const {
          title,
          titleIngles,
          multiple,
          opciones: opcionesAcabado,
          parentAcabado
        } = searchId(acabados, idAcabado)

        const idOpciones =
          parentAcabado !== ''
            ? getSubopcionesValidas(
                idAcabado,
                parentAcabado,
                opciones,
                opcionesSeleccionadas
              ).subopcionesSeleccionadas
            : searchId(opcionesSeleccionadas, idAcabado).opciones

        idOpciones.forEach(idOpcion => {
          const defaultOp = multiple
            ? false
            : opcionesAcabado.length === 0
            ? true
            : opcionesAcabado[0] === idOpcion

          const opcion = searchId(opciones, idOpcion)

          const index = result.length

          result.push({
            id: opcion.id,
            idEstancia: estancia.id,
            srcBase: estancia.src,
            idAcabado,
            index,
            acabadoTitle: idioma === 'es' ? title : titleIngles,
            title: idioma === 'es' ? opcion.title : opcion.titleIngles,
            subtitle: idioma === 'es' ? opcion.subtitle : opcion.subtitleIngles,
            srcIcono: opcion.srcIcono,
            srcOpcion: opcion.src,
            precio: number_format(opcion.precio, 2, ',', '.'),
            default: defaultOp
          })
        })
      })
    })

    return result
  }
)

export const getConfiguracionesGuardadas = createSelector(
  [
    estanciasSelector,
    acabadosSelector,
    opcionesSelector,
    configuracionesGuardadasSelector,
    idiomaSelector
  ],
  (estancias, acabados, opciones, configuracionesGuardadas, idioma) => {
    return configuracionesGuardadas.map(configuracion => {
      const confEstancias = configuracion.estancias.map(confEstancia => {
        const estancia = searchId(estancias, confEstancia.id)

        const confAcabados = confEstancia.acabados.map(confAcabado => {
          const acabado = searchId(acabados, confAcabado.id)

          const confOpciones = confAcabado.opciones.map(confOpcion => {
            const opcion = searchId(opciones, confOpcion)

            return {
              id: opcion.id,
              title: idioma === 'es' ? opcion.title : opcion.titleIngles,
              srcIcono: opcion.srcIcono,
              precio: opcion.precio
            }
          })

          return {
            id: acabado.id,
            title: idioma === 'es' ? acabado.title : acabado.titleIngles,
            opciones: confOpciones
          }
        })

        return {
          id: estancia.id,
          title: idioma === 'es' ? estancia.title : estancia.titleIngles,
          acabados: confAcabados
        }
      })

      return {
        id: configuracion.id,
        estancias: confEstancias
      }
    })
  }
)

export const getConfiguracionesSave = createSelector(
  [
    estanciasSelector,
    acabadosSelector,
    opcionesSeleccionadasSelector,
    opcionesSelector,
    idiomaSelector
  ],
  (estancias, acabados, opcionesSeleccionadas, opciones, idioma) => {
    return estancias.map(estancia => {
      const acabados1 = estancia.acabados.map(idAcabado => {
        const opcionesSeleccionadas1 = searchId(
          opcionesSeleccionadas,
          idAcabado
        )
        const acabado = searchId(acabados, idAcabado)

        const op = opcionesSeleccionadas1.opciones.map(idOpcion => {
          const opcion = searchId(opciones, idOpcion)

          return {
            id: idOpcion,
            gaTitle: opcion.title
          }
        })

        return {
          id: idAcabado,
          gaTitle: acabado.title,
          opciones: op
        }
      })

      return {
        id: estancia.id,
        gaTitle: estancia.title,
        acabados: acabados1
      }
    })
  }
)
/*
export const getOpcionesGuardadas = createSelector(
  [
    estanciasSelector,
    acabadosSelector,
    opcionesSelector,
    opcionesGuardadasSelector,
    idiomaSelector
  ],
  (estancias, acabados, opciones, opcionesGuardadas, idioma) => {
    return estancias.map(estancia => {
      const op = []

      for (let i = 0, iLen = opcionesGuardadas.length; i < iLen; i++) {
        if (opcionesGuardadas[i].idEstancia === estancia.id) {
          op.push({ ...opcionesGuardadas[i] })
        }
      }

      op.sort((a, b) => {
        if (a.orden < b.orden) {
          return -1
        } else if (a.orden > b.orden) {
          return 1
        } else {
          return 0
        }
      })

      const selecciones = op.map(opcionSave1 => {
        const acabados1 = opcionSave1.opciones.map(opcionSave => {
          const { title, titleIngles } = searchId(acabados, opcionSave.id)

          const opciones1 = opcionSave.opciones.map(idOpcion => {
            const opcion = searchId(opciones, idOpcion)

            return {
              idOpcion,
              title: idioma === 'es' ? opcion.title : opcion.titleIngles,
              subtitle:
                idioma === 'es' ? opcion.subtitle : opcion.subtitleIngles,
              srcIcono: opcion.srcIcono,
              precio: opcion.precio
            }
          })

          return {
            idAcabado: opcionSave.id,
            acabadoTitle: idioma === 'es' ? title : titleIngles,
            opciones: opciones1
          }
        })

        return {
          orden: opcionSave1.orden,
          acabados: acabados1,
          nid: opcionSave1.nid
        }
      })

      return {
        id: estancia.id,
        title: idioma === 'es' ? estancia.title : estancia.titleIngles,
        path: `/${idioma}/${estancia.path}`,
        selecciones
      }
    })
  }
)

export const getOpcionesSeleccionadasSave = createSelector(
  [estanciasSelector, acabadosSelector, opcionesSeleccionadasSelector],
  (estancias, acabados, opcionesSeleccionadas) => {
    return estancias.map(estancia => {
      const acabados = estancia.acabados.map(idAcabado => {
        return searchId(opcionesSeleccionadas, idAcabado)
      })

      return {
        id: estancia.id,
        acabados
      }
    })
  }
)
*/
export const getOpcionesSeleccionadasPdf = createSelector(
  [
    estanciasSelector,
    acabadosSelector,
    opcionesSelector,
    opcionesSeleccionadasSelector,
    idiomaSelector
  ],
  (estancias, acabados, opciones, opcionesSeleccionadas, idioma) => {
    return estancias.map(estancia => {
      const precio = getSubtotalAcabados(
        estancia.acabados,
        acabados,
        opciones,
        opcionesSeleccionadas
      )

      const acabados1 = estancia.acabados.map(idAcabado => {
        const acabado = searchId(acabados, idAcabado)

        const idOpciones =
          acabado.parentAcabado !== ''
            ? getSubopcionesValidas(
                idAcabado,
                acabado.parentAcabado,
                opciones,
                opcionesSeleccionadas
              ).subopcionesSeleccionadas
            : searchId(opcionesSeleccionadas, idAcabado).opciones

        const opciones1 = idOpciones.map(idOpcion => {
          const opcion = searchId(opciones, idOpcion)

          return {
            id: idOpcion,
            title: idioma === 'es' ? opcion.title : opcion.titleIngles,
            gaTitle: opcion.title,
            subtitle: idioma === 'es' ? opcion.subtitle : opcion.subtitleIngles,
            srcIcono: opcion.srcIcono,
            src: opcion.src,
            precio: number_format(opcion.precio, 2, ',', '.'),
            srcIconoPdf: opcion.srcIconoPdf
          }
        })

        return {
          title: idioma === 'es' ? acabado.title : acabado.titleIngles,
          gaTitle: acabado.title,
          opciones: opciones1
        }
      })

      return {
        id: estancia.id,
        title: idioma === 'es' ? estancia.title : estancia.titleIngles,
        gaTitle: estancia.title,
        src: estancia.src,
        acabados: acabados1,
        subtotal: number_format(precio, 2, ',', '.'),
        pdfIconosLinea: estancia.pdfIconosLinea
      }
    })
  }
)

export const getEstanciaActualTitle = createSelector(
  [estanciasSelector, idEstanciaActualSelector, idiomaSelector],
  (estancias, idEstanciaActual, idioma) => {
    const estancia = searchId(estancias, idEstanciaActual)
    return idioma === 'es' ? estancia.title : estancia.titleIngles
  }
)

export const getEstanciaActualGaTitle = createSelector(
  [estanciasSelector, idEstanciaActualSelector],
  (estancias, idEstanciaActual) => {
    const estancia = searchId(estancias, idEstanciaActual)
    return estancia.title
  }
)

createSelector(
  [estanciasSelector, idEstanciaActualSelector],
  (estancias, idEstanciaActual) => {
    const estancia = searchId(estancias, idEstanciaActual)
    return estancia.title
  }
)

export const getEndMenu = state => {
  return -(state.heightMenu - state.heightViewport)
}

const widthButtonEstanciaSelector = state => state.widthButtonEstancia
const widthSliderButtonsSelector = state => state.widthSliderButtons

export const getButtonEstanciaX = createSelector(
  [widthButtonEstanciaSelector],
  widthButtonEstancia => {
    let leftX = 0

    return widthButtonEstancia.map(widthEstancia => {
      const antLeftX = leftX
      const newLeftX = leftX + widthEstancia + 40

      leftX = newLeftX

      return { left: antLeftX, right: newLeftX }
    })
  }
)

export const getEndSliderButtons = createSelector(
  [getButtonEstanciaX, widthSliderButtonsSelector],
  (buttonEstanciaX, widthSliderButtons) =>
    widthSliderButtons - buttonEstanciaX[buttonEstanciaX.length - 1].right
)

export const getPrevNextEstancias = createSelector(
  [estanciasSelector, idEstanciaActualSelector, idiomaSelector],
  (estancias, idEstanciaActual, idioma) => {
    const result = { prev: null, next: null }

    const iLen = estancias.length

    if (iLen === 0 || iLen === 1) return result

    for (let i = 0; i < iLen; i++) {
      if (estancias[i].id === idEstanciaActual) {
        if (i === 0) {
          result.prev = null

          result.next = {
            path: `/${idioma}/${estancias[1].path}`,
            src: estancias[1].src,
            width: estancias[1].width,
            height: estancias[1].height
          }

          return result
        }
        if (i === estancias.length - 1) {
          result.prev = {
            path: `/${idioma}/${estancias[i - 1].path}`,
            src: estancias[i - 1].src,
            width: estancias[i - 1].width,
            height: estancias[i - 1].height
          }
          result.next = null
          return result
        }

        result.prev = {
          path: `/${idioma}/${estancias[i - 1].path}`,
          src: estancias[i - 1].src,
          width: estancias[i - 1].width,
          height: estancias[i - 1].height
        }
        result.next = {
          path: `/${idioma}/${estancias[i + 1].path}`,
          src: estancias[i + 1].src,
          width: estancias[i + 1].width,
          height: estancias[i + 1].height
        }
        return result
      }
    }
  }
)

const textosSelector = state => state.textos
const textosInglesSelector = state => state.textosIngles

export const getTextoInformacion = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.informacion : textosIngles.informacion
)

export const getTextoCerrarInformacion = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.cerrar : textosIngles.cerrar
)

export const getTextoIva = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.iva : textosIngles.iva
)

export const getTextoBotonResumen = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.botonResumen : textosIngles.botonResumen
)

export const getTextoBotonReset = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.botonReset : textosIngles.botonReset
)

export const getTextoGenerarPDF = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.generarPDF : textosIngles.generarPDF
)

export const getTextoGuardarConfiguraciones = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es'
      ? textos.guardarConfiguraciones
      : textosIngles.guardarConfiguraciones
)

export const getTextoCerrarSeleccionadas = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.cerrar : textosIngles.cerrar
)

export const getTextoMiPerfil = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.miPerfil : textosIngles.miPerfil
)

export const getTextoConfiguraciones = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.configuraciones : textosIngles.configuraciones
)

export const getTextoCerrarSesion = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.cerrarSesion : textosIngles.cerrarSesion
)

export const getTextoGuardar = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.guardar : textosIngles.guardar
)

export const getTextoMaximoConfiguraciones = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es'
      ? textos.maximoConfiguraciones
      : textosIngles.maximoConfiguraciones
)

export const getTextoConfiguracion = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.configuracion : textosIngles.configuracion
)

export const getTextoRecuperar = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.recuperar : textosIngles.recuperar
)

export const getTextoEliminar = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.eliminar : textosIngles.eliminar
)

export const getTextoPerfilUsuario = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.perfilUsuario : textosIngles.perfilUsuario
)

export const getTextoCookies = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.cookies : textosIngles.cookies
)

export const getTextoAceptar = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.aceptar : textosIngles.aceptar
)

export const getTextoRechazar = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.rechazar : textosIngles.rechazar
)

export const getTextoEnviarCorreo = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.enviarCorreo : textosIngles.enviarCorreo
)

export const getTextoLegal = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.legal : textosIngles.legal
)

export const getTextoCerrarLegal = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.cerrar : textosIngles.cerrar
)

export const getTextoErrorEmail = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.errorEmail : textosIngles.errorEmail
)

export const getTextoNoUser = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.noUser : textosIngles.noUser
)

export const getTextoAvisoCorreo = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.avisoCorreo : textosIngles.avisoCorreo
)

export const getTextoIdentificarse = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.identificarse : textosIngles.identificarse
)

export const getTextoRegistrarUsuario = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.registrarUsuario : textosIngles.registrarUsuario
)

export const getTextoEmail = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.email : textosIngles.email
)

export const getTextoNombre = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.nombre : textosIngles.nombre
)

export const getTextoMovil = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.movil : textosIngles.movil
)

export const getTextoCodigoPostal = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.codigoPostal : textosIngles.codigoPostal
)

export const getTextoAcepto = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.acepto : textosIngles.acepto
)

export const getTextoTerminos = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.terminos : textosIngles.terminos
)

export const getTextoErrorConfiguraciones = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es'
      ? textos.errorConfiguraciones
      : textosIngles.errorConfiguraciones
)

export const getTextoErrorCondiciones = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.errorCondiciones : textosIngles.errorCondiciones
)

export const getTextoErrorNombre = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.errorNombre : textosIngles.errorNombre
)

export const getTextoCrearUsuario = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.crearUsuario : textosIngles.crearUsuario
)

export const getTextoHeaderPdf = createSelector(
  [idiomaSelector, textosSelector, textosInglesSelector],
  (idioma, textos, textosIngles) =>
    idioma === 'es' ? textos.headerPdf : textosIngles.headerPdf
)
